module.exports = __webpack_public_path__ + "img/schf.98ef0d7.png";